import { render, staticRenderFns } from "./projectInfoFields.vue?vue&type=template&id=3f9eb5e0&"
import script from "./projectInfoFields.vue?vue&type=script&lang=js&"
export * from "./projectInfoFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports